import { queryOptions } from '@tanstack/react-query';
import type { ScoutingPageParams } from '@/marketing/models/campaignScouting';
import { campaignScoutingAPIClient } from './campaignScoutingAPIClient';
export const SCOUTING_KEYS = {
  all: ['campaignScouting'] as const,
  list: (campaignId: string) => ['campaignScouting', campaignId] as const,
  pages: (campaignId: string) => ['campaignScouting', campaignId, 'page'] as const,
  page: (campaignId: string, params: ScoutingPageParams) => ['campaignScouting', campaignId, 'page', params] as const,
};
export const scoutingQuery = (campaignId: string) =>
  queryOptions({
    queryKey: SCOUTING_KEYS.list(campaignId),
    queryFn: () => campaignScoutingAPIClient.list(campaignId),
    enabled: campaignId !== '',
    staleTime: 0,
    retry: false,
  });

export const scoutingPageQuery = (campaignId: string, params: ScoutingPageParams) =>
  queryOptions({
    queryKey: SCOUTING_KEYS.page(campaignId, params),
    queryFn: async ({ signal }) => {
      const page = await campaignScoutingAPIClient.page(campaignId, params, signal);
      if (params.status === 'Finalist' && (page.pageInfo.hasMore || page.pageInfo.nextCursor)) {
        throw new Error('The full finalist list is unavailable. Refresh and try again.');
      }
      return page;
    },
    enabled: campaignId !== '',
    staleTime: 30_000,
    retry: false,
  });
